import { render, staticRenderFns } from "./PlatformAdmins.vue?vue&type=template&id=68acc5ac&scoped=true&"
import script from "./PlatformAdmins.vue?vue&type=script&lang=js&"
export * from "./PlatformAdmins.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAdmins.vue?vue&type=style&index=0&id=68acc5ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68acc5ac",
  null
  
)

export default component.exports